import React from "react";
import {
    IMessagePageContent,
    IFeaturedProduct,
    IProductGrid,
    IEducational,
    IHero
} from "../services/interface/data";

import Hero from "./Hero/Hero";
import FeaturedProduct from "./FeaturedProduct/FeaturedProduct";
import ProductGrid from "./ProductGrid/ProductGrid";
import EducationalContent from "./EducationalContent/EducationalContent";
import StaticHeadline from "./StaticHeadline/StaticHeadline";

const renderSection = (contentItem: IMessagePageContent) => {
    const { component_type, component_id, component_properties } = contentItem;

    const component: {
        [key: string]: () => JSX.Element;
    } = {
        hero: () => {
            const properties: IHero = component_properties as IHero;
            return (
                <Hero
                    key={`hero-${component_id}`}
                    header={properties.headline}
                    backgroundImage={properties.source}
                />
            );
        },
        featured_product: () => {
            const properties: IFeaturedProduct =
                component_properties as IFeaturedProduct;
            return (
                <FeaturedProduct
                    id={component_id}
                    key={`FeaturedProduct-${component_id}`}
                    variant={properties.component_variant}
                    sku={properties.sku}
                    description={properties.description}
                    backgroundImage={properties.background_image}
                    attributes={properties.attributes}
                    isHero={properties.is_hero}
                    tagline={properties.tagline}
                    isFullBackground={properties.is_full_background}
                />
            );
        },
        product_grid: () => {
            const properties: IProductGrid =
                component_properties as IProductGrid;

            return (
                <div
                    id={component_id}
                    key={`grid-wrapper-${component_id}`}
                    className="grid-wrapper"
                >
                    <StaticHeadline
                        headline={properties.headline}
                        subHeadline={properties.sub_headline}
                    />
                    <ProductGrid
                        headline={properties.headline}
                        subHeadline={properties.sub_headline}
                        products={properties.products}
                    />
                </div>
            );
        },
        educational: () => {
            const properties: IEducational =
                component_properties as IEducational;
            return (
                <EducationalContent
                    id={component_id}
                    key={`EducationalContent-${component_id}`}
                    variant={properties.component_variant}
                    tagline={properties.tagline}
                    description={properties.description}
                    link={properties.link}
                    assets={properties.assets}
                />
            );
        },
    };

    const comp = component[component_type];

    if (comp) {
        return comp();
    } else {
        return <div key={`no-content-${component_id}`} />;
    }
};

export default renderSection;
